import AiNavigatorHealth from "./AiNavigatorHealth";

export default AiNavigatorHealth;